import $ from 'jquery';
import { defaultAddonValues, matchesVariant as matches } from './addon-variant-defaults';

const root = document.querySelector('[data-product-addons]');
if (root) {
    const form = root.closest('form.cart');
    const content = root.querySelector('[data-addon-content]');
    const toggle = root.querySelector('[data-addon-toggle]');
    const feedback = root.querySelector('[data-addon-feedback]');
    const retry = root.querySelector('[data-addon-retry]');
    const submit = form?.querySelector('.single_add_to_cart_button');
    const states = new Map();
    const disabledBefore = new Map();
    let config = null;
    let formatter = null;
    let loading = false;
    let busy = false;
    let expanded = true;
    let showAll = false;
    let needsRefresh = false;
    let pendingPayload = null;
    let uncertain = false;
    let current = null;
    let giftSelected = false;
    let previousBaseValues = '';
    toggle.hidden = false;

    const announce = (message = '', error = false) => {
        feedback.textContent = message;
        feedback.hidden = !message;
        feedback.dataset.error = String(error);
    };
    const money = amount => formatter.format(amount / (10 ** config.decimals));
    const baseValues = () => Object.fromEntries(Array.from(form.querySelectorAll('select[name^="attribute_"]')).map(el => [el.name, el.value]));
    const selectedVariant = (item, values) => item.attributes.every(attr => values[attr.name])
        ? item.variants.find(variant => variant.available && matches(variant, values)) : null;
    const cheapest = item => item.variants.filter(variant => variant.available).reduce((best, variant) => !best || variant.amount < best.amount ? variant : best, null);
    const selection = (item, state) => ({ product_id: item.id, variation_id: state.variant.id, attributes: state.values, token: state.variant.token });
    const setExpanded = value => {
        expanded = value;
        content.hidden = !value;
        toggle.setAttribute('aria-expanded', String(value));
        toggle.textContent = value ? 'Zwiń ↑' : (giftSelected || [...states.values()].some(state => state.selected) ? 'Edytuj zestaw →' : 'Stwórz zestaw →');
    };
    const lock = value => {
        if (value) {
            form.querySelectorAll('input, select, button').forEach(el => {
                if (!disabledBefore.has(el)) disabledBefore.set(el, el.disabled);
                el.disabled = true;
            });
        } else {
            disabledBefore.forEach((disabled, el) => { if (el.isConnected) el.disabled = disabled; });
            disabledBefore.clear();
        }
        root.setAttribute('aria-busy', String(value));
        submit?.classList.toggle('is-adding', value);
        submit?.setAttribute('aria-busy', String(value));
    };
    const rowOptions = (row, value) => {
        const options = row.querySelector('[data-addon-options]');
        if (!options) return;
        options.hidden = !value;
        row.querySelector('[data-addon-edit]').setAttribute('aria-expanded', String(value));
    };
    const update = () => {
        if (!config) return;
        const base = { item: config.items[0], values: baseValues() };
        const signature = JSON.stringify(base.values);
        if (signature !== previousBaseValues) {
            states.forEach(state => {
                if (!state.manual) state.values = defaultAddonValues(state.item, base.item, base.values, state.values);
            });
            previousBaseValues = signature;
        }
        base.variant = selectedVariant(base.item, base.values);
        const baseChoice = base.variant || cheapest(base.item);
        const extras = [...states.values()].filter(state => state.selected);
        const hasExtras = extras.length > 0 || giftSelected;
        let total = hasExtras ? (baseChoice?.amount || 0) : (baseChoice?.normal || 0);
        let paid = total > 0 ? 1 : 0;
        let ready = Boolean(base.variant);
        states.forEach(state => {
            const { item, row, values } = state;
            state.variant = selectedVariant(item, values);
            const quote = state.variant || cheapest(item);
            const checkbox = row.querySelector('[data-addon-select]');
            checkbox.checked = state.selected;
            const label = item.attributes.map(attr => attr.options.find(option => option.value === values[attr.name])?.label).filter(Boolean).join(' · ');
            row.querySelector('[data-addon-variant]').textContent = !item.available ? 'Niedostępny' : (label || (item.attributes.length ? 'Wybierz wariant' : 'W zestawie'));
            const price = row.querySelector('[data-addon-price]');
            price.textContent = quote ? `${state.variant ? '' : 'od '}${money(quote.amount)}` : 'Niedostępny';
            const normal = row.querySelector('[data-addon-normal]');
            normal.hidden = !quote || quote.normal <= quote.amount;
            normal.textContent = quote ? money(quote.normal) : '';
            const discount = row.querySelector('[data-addon-discount]');
            if (discount) discount.hidden = normal.hidden;
            row.querySelector('[data-addon-image]').innerHTML = state.variant?.image || item.image;
            row.querySelectorAll('[data-addon-attribute]').forEach(select => {
                select.value = values[select.dataset.addonAttribute] || '';
                Array.from(select.options).forEach(option => {
                    option.disabled = Boolean(option.value) && !item.variants.some(variant => variant.available && matches(variant, { ...values, [select.dataset.addonAttribute]: option.value }));
                });
            });
            const availability = row.querySelector('[data-addon-availability]');
            if (availability) availability.textContent = state.variant ? (state.variant.stock_note || '') : 'Wybierz dostępny kolor i rozmiar.';
            if (state.selected) {
                total += quote?.amount || 0;
                if (quote?.amount > 0) paid++;
                ready = ready && Boolean(state.variant);
            }
            row.hidden = Number(row.dataset.addonIndex) >= 3 && !showAll && !state.selected;
        });
        const giftActive = Boolean(config.gift?.available && paid >= config.set.gift_threshold && extras.length);
        const giftRow = content.querySelector('[data-addon-gift]');
        if (giftRow) {
            giftRow.classList.toggle('ProductAddons__item--gift', giftActive);
            const checkbox = giftRow.querySelector('[data-addon-gift-select]');
            checkbox.hidden = giftActive;
            checkbox.checked = giftSelected;
            checkbox.disabled = !config.gift.available || giftActive;
            giftRow.querySelector('[data-addon-gift-label]').hidden = giftActive || !config.gift.available;
            giftRow.querySelector('[data-addon-gift-icon]').hidden = !giftActive;
            const normal = giftRow.querySelector('[data-addon-gift-normal]');
            normal.hidden = !giftActive || !config.gift.normal;
            normal.textContent = money(config.gift.normal);
            giftRow.querySelector('[data-addon-gift-price]').textContent = money(giftActive ? 0 : config.gift.normal);
            giftRow.querySelector('[data-addon-gift-variant]').textContent = config.gift.available ? config.gift.variant : 'Niedostępny';
        }
        if (giftSelected && !giftActive) total += config.gift.normal;
        const count = extras.length + 1 + Number(giftSelected);
        content.querySelector('[data-addon-count]').textContent = giftActive ? `${paid} płatne + 1 gratis` : `${count} ${count === 1 ? 'produkt' : count < 5 ? 'produkty' : 'produktów'}`;
        const totalLabel = `${ready ? '' : 'od '}${money(total)}`;
        content.querySelector('[data-addon-total]').textContent = totalLabel;
        form.dispatchEvent(new CustomEvent('ravessa:addons-total', { detail: hasExtras ? totalLabel : null }));
        root.querySelector('[data-addon-offer]').textContent = giftActive
            ? (ready ? 'Twój zestaw z gratisem jest gotowy.' : 'Gratis jest Twój. Wybierz jeszcze wariant produktu głównego.')
            : config.gift?.available
                ? (config.set.gift_threshold - paid === 1 ? 'Jeszcze jeden dodatek i gratis jest Twój.' : `Do gratisu brakuje ${Math.max(0, config.set.gift_threshold - paid)} płatnych dodatków.`)
                : (config.set.gift_id ? 'Gratis jest chwilowo niedostępny. Możesz wybrać same dodatki.' : 'Dobierz dodatki, które pasują do Ciebie.');
        let badge = root.querySelector('[data-addon-badge]');
        if (!badge && config.gift?.available) {
            badge = document.createElement('span');
            badge.className = 'ProductAddons__badge'; badge.dataset.addonBadge = '';
            root.querySelector('.ProductAddons__heading').append(badge);
        }
        if (badge) {
            badge.hidden = !config.gift?.available;
            badge.textContent = `${config.set.gift_threshold} + 1 GRATIS`;
        }
        current = { base, extras, giftActive, ready, hasExtras };
        setExpanded(expanded);
    };
    const load = async () => {
        if (loading || busy || uncertain) return;
        loading = true;
        toggle.disabled = true;
        retry.hidden = true;
        content.setAttribute('aria-busy', 'true');
        announce('Wczytuję dodatki…');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
            const url = new URL(root.dataset.endpoint, location.href);
            url.search = new URLSearchParams({ action: 'ravessa_product_set', product_id: root.dataset.productId, set_id: root.dataset.setId }).toString();
            const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
            const result = await response.json();
            if (!response.ok || !result.success) throw new Error(result.data?.message || 'Nie udało się wczytać dodatków.');
            const saved = new Map([...states].map(([id, state]) => [id, { selected: state.selected, values: state.values, manual: state.manual }]));
            const previousGift = config?.gift;
            const hadGiftSelected = giftSelected;
            config = result.data;
            giftSelected = Boolean(giftSelected && config.gift?.available && previousGift?.id === config.gift.id && previousGift?.variation_id === config.gift.variation_id);
            formatter = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: config.currency, minimumFractionDigits: config.decimals });
            content.innerHTML = config.html;
            states.clear();
            const mainValues = baseValues();
            previousBaseValues = JSON.stringify(mainValues);
            config.items.slice(1).forEach(item => {
                const row = content.querySelector(`[data-addon-product="${item.id}"]`);
                const before = saved.get(item.id);
                // Refresh must never silently change a customer's chosen size or colour.
                const values = before ? before.values : defaultAddonValues(item, config.items[0], mainValues);
                states.set(item.id, { item, row, values, selected: Boolean(before?.selected && item.available), manual: Boolean(before?.manual), variant: null });
            });
            needsRefresh = false;
            const unavailable = (hadGiftSelected && !giftSelected) || [...saved].some(([id, state]) => state.selected && (!states.get(id)?.selected || !selectedVariant(states.get(id).item, state.values)));
            announce(unavailable ? 'Dostępność dodatków się zmieniła. Sprawdź zaznaczone produkty i wybierz dostępne warianty.' : '', unavailable);
            update();
        } catch (error) {
            needsRefresh = true;
            announce(error.name === 'AbortError' ? 'Wczytywanie trwa zbyt długo. Spróbuj ponownie.' : error.message, true);
            retry.textContent = 'Odśwież dodatki'; retry.hidden = false;
        } finally {
            clearTimeout(timeout);
            loading = false;
            toggle.disabled = false;
            content.setAttribute('aria-busy', 'false');
        }
    };
    const add = async () => {
        if (busy || loading) return;
        if (!pendingPayload) {
            if (needsRefresh) { announce('Odśwież dodatki przed zakupem.', true); retry.hidden = false; return; }
            update();
            if (!current?.hasExtras) return;
            if (!current.ready) {
                announce('Wybierz dostępne warianty wszystkich wybranych produktów.', true);
                if (!current.base.variant) form.querySelector('select[name^="attribute_"]')?.focus();
                else {
                    const missing = current.extras.find(state => !state.variant);
                    setExpanded(true); rowOptions(missing.row, true); missing.row.querySelector('select')?.focus();
                }
                return;
            }
            if (Number(form.querySelector('[name="quantity"]')?.value || 1) !== 1) { announce('Zestaw zawiera po jednej sztuce wybranych produktów. Ustaw ilość na 1.', true); return; }
            const items = [selection(current.base.item, current.base), ...current.extras.map(state => selection(state.item, state))];
            if (current.giftActive || giftSelected) items.push({ product_id: config.gift.id, variation_id: config.gift.variation_id, attributes: config.gift.attributes, token: current.giftActive ? config.gift.token : config.gift.paid_token, paid: !current.giftActive });
            pendingPayload = { action: 'ravessa_add_product_set', product_id: root.dataset.productId, set_id: config.set.id, revision: config.revision, nonce: config.nonce, request_id: config.request_id, items: JSON.stringify(items) };
        }
        busy = true; uncertain = false; lock(true); retry.hidden = true; announce('Dodaję wybrane produkty…');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
            const response = await fetch(root.dataset.endpoint, { method: 'POST', credentials: 'same-origin', body: new URLSearchParams(pendingPayload), signal: controller.signal });
            const result = await response.json();
            if (!response.ok || !result.success) {
                if (response.status >= 500 || response.status === 409) throw new Error('uncertain');
                pendingPayload = null;
                needsRefresh = true;
                lock(false);
                announce(result.data?.message || 'Odśwież dodatki i spróbuj ponownie.', true);
                retry.textContent = 'Odśwież dodatki'; retry.hidden = false;
                return;
            }
            pendingPayload = null;
            config.request_id = result.data.request_id;
            lock(false);
            announce('Wybrane produkty są już w koszyku.');
            $(document.body).trigger('added_to_cart', [{}, result.data.cart_hash, $(submit)]);
            $(document.body).trigger('wc_fragment_refresh');
        } catch (error) {
            uncertain = true;
            root.setAttribute('aria-busy', 'false');
            submit.classList.remove('is-adding'); submit.setAttribute('aria-busy', 'false'); submit.disabled = false;
            announce('Nie udało się potwierdzić dodania. Ponów sprawdzenie — zestaw nie zostanie dodany drugi raz.', true);
            retry.textContent = 'Sprawdź dodanie zestawu'; retry.hidden = false; retry.disabled = false;
        } finally {
            busy = false;
            clearTimeout(timeout);
        }
    };
    toggle.addEventListener('click', async () => {
        setExpanded(!expanded);
        if (expanded && (!config || needsRefresh)) await load();
    });
    retry.addEventListener('click', () => uncertain ? add() : load());
    content.addEventListener('change', event => {
        if (busy || uncertain) return;
        if (event.target.matches('[data-addon-gift-select]')) {
            giftSelected = event.target.checked && config.gift.available;
            announce(); update();
            return;
        }
        const row = event.target.closest('[data-addon-product]');
        if (!row) return;
        const state = states.get(Number(row.dataset.addonProduct));
        if (event.target.matches('[data-addon-select]')) {
            state.selected = event.target.checked;
            if (!state.selected) rowOptions(row, false);
        } else if (event.target.matches('[data-addon-attribute]')) {
            state.values[event.target.dataset.addonAttribute] = event.target.value;
            state.manual = true;
        }
        announce(); update();
    });
    content.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || busy || uncertain) return;
        if (button.hasAttribute('data-addon-close')) { setExpanded(false); toggle.focus(); }
        if (button.hasAttribute('data-addon-more')) {
            showAll = !showAll;
            button.setAttribute('aria-expanded', String(showAll));
            const count = Number(button.dataset.count);
            button.textContent = showAll ? 'Pokaż mniej dodatków ↑' : `Pokaż jeszcze ${count} ${count === 1 ? 'dodatek' : count < 5 ? 'dodatki' : 'dodatków'} ↓`;
            update();
        }
        const row = button.closest('[data-addon-product]');
        if (!row) return;
        if (button.hasAttribute('data-addon-edit')) {
            rowOptions(row, row.querySelector('[data-addon-options]').hidden);
            if (!row.querySelector('[data-addon-options]').hidden) row.querySelector('select')?.focus();
        }
        if (button.hasAttribute('data-addon-edit-done')) { rowOptions(row, false); row.querySelector('[data-addon-edit]').focus(); }
    });
    root.addEventListener('keydown', event => {
        if (event.key === 'Escape' && expanded && !busy && !uncertain) { event.preventDefault(); setExpanded(false); toggle.focus(); }
    });
    form.addEventListener('submit', event => {
        if (!pendingPayload && !giftSelected && ![...states.values()].some(state => state.selected)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        add();
    });
    $(form).on('found_variation.ravessaAddons reset_data.ravessaAddons woocommerce_variation_has_changed.ravessaAddons', () => {
        if (!busy && !uncertain) update();
    });
    form.addEventListener('change', event => {
        if (event.target.matches('select[name^="attribute_"]') && !busy && !uncertain) update();
    });
    setExpanded(expanded);
    load();
}
